<template>
    <fragment v-if="subscriptionDetails.has_real_credits">
        <light-header></light-header>

        <div class="app-content" style="padding-bottom: 100px">
            <div class="sm-container" id="app">
                <form action="" method="get" id="light-report-form">
                    <div class="columns" id="valuation-calculator" style="margin-top: 16px;">
                        <div class="column">
                            <div class="title-lg">
                                Industry and Country Statistics
                            </div>
                            <div>
                                Choose the industry and country you're interested in to get related industry and country
                                statistics.
                            </div>
                            <div class="sep-16"></div>
                            <div class="field">
                                <label class="label">
                                    Report Title
                                </label>
                                <div class="control">
                                    <input v-model="label" type="text"
                                           placeholder="Report Title"
                                           class="input" vrules="required">
                                </div>
                                <div class="help is-danger vrule" rule="required">
                                    This field is required.
                                </div>
                            </div>
                            <div class="sep-16"></div>
                            <div class="field is-big">
                                <label class="label" for="industry">
                                    Industry?
                                </label>
                                <div class="sep-16"></div>
                                <div class="control block-select-fullwidth ">
                                    <div class="select  is-medium">
                                        <select v-model="industryId" name="industry"
                                                id="industry" vrules="required">
                                            <option v-for="industry in industries" :value="industry.id">
                                                {{ industry.name }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="vrule help is-danger" rule="required">
                                        This field is required.
                                    </div>
                                </div>
                            </div>
                            <div class="field is-big">
                                <label class="label">
                                    In which country is the company based?
                                </label>
                                <div class="sep-16"></div>
                                <div class="control block-select-fullwidth">
                                    <div class="select  is-medium">
                                        <select v-model="countryId" name="country"
                                                id="country" vrules="required">
                                            <option v-for="country in countries" :value="country.id">
                                                {{ country.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="vrule help is-danger" rule="required">
                                        This field is required.
                                    </div>
                                </div>
                            </div>
                            <div class="sep-16"></div>
                            <div class="valuation-buttons">
                                <button class="button is-primary is-medium is-fullwidth" :class="{'is-loading': loading}" @click.prevent="submitReport()">
                                    Submit
                                </button>
                            </div>
                        </div>

                    </div>
                </form>

            </div>
        </div>
    </fragment>
</template>
<script>
    import {LookupsAPI} from "../../../apis/LookupsAPI";
    import LightHeader from "../../../shared/components/LightHeader";
    import {ReportAPI} from "../../../apis/ReportAPI";
    import {FormValidation} from "../../../shared/directives/formValidation";

    export default {
        name: "LightCalculator",
        components: {
            LightHeader,
        },
        data() {
            return {
                industryId: '',
                countryId: '',
                label: '',
                loading: false,
                countries: [],
                industries: [],
            }
        },
        async mounted() {
            SFAnalytics.track('Light Valuation Started');
            await this.$store.dispatch('account/updateSubscriptionDetails');
            this.countries = await LookupsAPI.getCountries();
            this.industries = await LookupsAPI.getIndustries()
        },
        methods: {
            async submitReport() {

                let formValidation = new FormValidation('#light-report-form')
                if (formValidation.runAllValidations() ) {
                    this.loading = true;
                    let resp = await ReportAPI.submitLightReport(this.countryId, this.industryId, this.label)

                    if (resp.httpStatus === 200) {
                      SFAnalytics.track('Light Valuation Complete');
                      this.$router.push({name: 'report_light', params: {'id': resp.report_id}});
                    } else {
                      this.$buefy.dialog.alert('Opps..! Something wrong happened please try again later.')
                    }
                    setTimeout(()=>{
                      this.loading = false;
                    }, 100);
                }

            },

        },
        computed: {
          subscriptionDetails(){
                return this.$store.state.account.subscriptionDetails;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .close-link {
        position: absolute;
        right: 20px;
        top: 20px;

        .st0 {
            fill: #A7ACB2;
        }
    }
</style>
